import { render, staticRenderFns } from "./PostComponent.vue?vue&type=template&id=701448ad"
import script from "./PostComponent.vue?vue&type=script&lang=js"
export * from "./PostComponent.vue?vue&type=script&lang=js"
import style0 from "./PostComponent.vue?vue&type=style&index=0&id=701448ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports